














































































import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { defineComponent, computed, ref, watch } from '~/utils/nuxt3-migration'
import { mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { Searchable } from '~/models/search/types'
import { Option } from '~/models/shared/types'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import CClassifiedMakeCustomSelect from '~/components/shared/configurable/classified/CClassifiedMakeCustomSelect.vue'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CClassifiedMakeCustomSelect,
    CCustomSelect
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, {
      loadingFacets: state => state.loading.facets
    })
  },
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()

    const selectedMakesValues = ref([
      ...props.allValues.typed.makes,
      ...props.allValues.untyped.makes.map((make: string) => `untyped:${make}`)
    ])
    const selectedModelsValues = ref([
      ...props.allValues.typed.models,
      ...props.allValues.untyped.models.map(
        (model: string) => `untyped:${model}`
      )
    ])
    const selectedRegistration = ref(props.allValues.registration || null)
    const useSearchInDescription = ref(props.allValues.text_search)

    watch(
      () => props.allValues,
      (newValues: any) => {
        selectedMakesValues.value = [
          ...newValues.typed.makes,
          ...newValues.untyped.makes.map((make: string) => `untyped:${make}`)
        ]
        selectedModelsValues.value = [
          ...newValues.typed.models,
          ...newValues.untyped.models.map((model: string) => `untyped:${model}`)
        ]
        selectedRegistration.value = newValues.registration || null
        useSearchInDescription.value = newValues.text_search
      }
    )

    const makesOptions = computed<Option[]>(() => {
      const typesMakesSearchables = props.searchables?.typed_makemodels || []
      const untypedMakesSearchables = (
        props.searchables?.untyped_makemodels?.makes || []
      ).map((make: Searchable) => ({
        ...make,
        v: `untyped:${make.v}`
      }))

      const topTypedMakes = typesMakesSearchables.filter(
        (make: any) => make.is_top
      )
      const defaultTypedMakes = typesMakesSearchables.filter(
        (make: any) => !make.is_top
      )

      const allSearchables = [
        ...topTypedMakes,
        ...defaultTypedMakes,
        ...untypedMakesSearchables
      ]

      return allSearchables.map((searchable: Searchable) => ({
        label: searchable.n,
        value: searchable.v,
        count: searchable.c
      }))
    })

    const modelsOptionGroups = computed(() => {
      const selectedMakes =
        props.searchables?.typed_makemodels.filter(
          (make: Searchable) => make.s
        ) || []

      return selectedMakes
        .filter((make: Searchable) => make.k)
        .map((make: Searchable) => ({
          label: make.n,
          options: make.k.map((model: Searchable) => ({
            label: model.n,
            value: model.v,
            count: model.c
          }))
        }))
    })

    const modelsOptions = computed(() => {
      const untypedModelsSearchables = (
        props.searchables?.untyped_makemodels?.models || []
      ).map((model: Searchable) => ({
        ...model,
        v: `untyped:${model.v}`
      }))

      return untypedModelsSearchables.map((searchable: Searchable) => ({
        label: searchable.n,
        value: searchable.v,
        count: searchable.c
      }))
    })

    const registrationOptions = computed(() =>
      (props.searchables.years || []).map((year: Searchable) => ({
        label: year.n,
        value: year.v
      }))
    )

    function onRegistrationChange(value: string | null) {
      changeParams([
        {
          name: 'registration',
          value
        }
      ])
    }

    function onClearMakeClick() {
      selectedMakesValues.value = []
      selectedModelsValues.value = []

      changeParams([
        { name: 'makes', value: [] },
        { name: 'makes_ids', value: [] },
        { name: 'models', value: [] },
        { name: 'models_ids', value: [] }
      ])
    }

    function onClearRegistrationClick() {
      selectedRegistration.value = null

      changeParams([{ name: 'registration', value: null }])
    }

    function onClearModelClick() {
      selectedModelsValues.value = []

      changeParams([
        { name: 'models', value: [] },
        { name: 'models_ids', value: [] }
      ])
    }

    function onMakesChange(makesIds: number) {
      const typesValues = makesIds.filter(
        (id: number) => !id.toString().startsWith('untyped:')
      )
      const untypedValues = makesIds
        .filter((v: number) => v.toString().startsWith('untyped:'))
        .map((v: string) => v.replace('untyped:', ''))

      changeParams([
        {
          name: 'makes_ids',
          value: typesValues
        },
        {
          name: 'makes',
          value: untypedValues
        }
      ])
    }

    function onModelsChange(modelsIds: number[]) {
      const typesValues = modelsIds.filter(
        (id: number) => !id.toString().startsWith('untyped:')
      )
      const untypedValues = modelsIds
        .filter((v: number) => v.toString().startsWith('untyped:'))
        .map((v: string) => v.replace('untyped:', ''))

      changeParams([
        {
          name: 'models_ids',
          value: typesValues
        },
        {
          name: 'models',
          value: untypedValues
        }
      ])
    }

    function onSearchInDescriptionChange(value: boolean) {
      changeParams([
        {
          name: 'make-models-strict-search',
          value: !value
        }
      ])
    }

    return {
      selectedMakesValues,
      selectedModelsValues,
      selectedRegistration,
      useSearchInDescription,
      makesOptions,
      modelsOptions,
      modelsOptionGroups,
      registrationOptions,
      onMakesChange,
      onModelsChange,
      onSearchInDescriptionChange,
      onRegistrationChange,
      onClearMakeClick,
      onClearRegistrationClick,
      onClearModelClick
    }
  }
})
